import { Text } from '@taxdown/piccolo-web';
import { useTranslation } from 'Hooks/useTranslation';
import Arrow from 'Components/icons/Arrow';
import * as Styled from './styles';
import { TabLinksProps } from './types';

const TabLinks = ({ links, activeLink }: TabLinksProps): JSX.Element => {
  const { t } = useTranslation();
  const handleOnClick = (callback: () => void): void => {
    callback();
  };
  return (
    <Styled.LinksContainer>
      {links.map(({ label, action }, index) => (
        <Styled.FlexContainer
          align="center"
          justify="space-between"
          key={label}
          isActive={activeLink === index}
          onClick={() => handleOnClick(action)}
        >
          <Text type="paragraphs" size="M_S_S" color="dark">
            {t(label)}
          </Text>
          <Arrow />
        </Styled.FlexContainer>
      ))}
    </Styled.LinksContainer>
  );
};

TabLinks.defaultProps = {
  activeLink: null,
};

export default TabLinks;
